import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'sera-tree',
    templateUrl: './sera-tree.component.html',
    styleUrls: ['./sera-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class SeraTreeComponent {
    @Input()
    value: TreeNode[] = [];

    @Input()
    selection: TreeNode<any> | TreeNode<any>[] | null = {};

    @Output() nodeSelection: EventEmitter<any> = new EventEmitter();

    emitNodeSelection(event: any): void {
        this.nodeSelection.emit(event);
    }
}
